import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: 'calc(100% - 30px)',
        overflow: 'auto'
    },
    table: {
        height: '100%',
    },
    tableHeadCell: {
        backgroundColor: theme.palette.grey.light,
        position: 'sticky',
        top: 0,
        zIndex: 10,
    },
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    }
}));
